import React from 'react'
import {
  Card,
  CardContent,
  Tooltip,
  Typography,
  FormHelperText,
  Grid,
  CardHeader,
  Zoom,
  FormControl,
  Divider
} from '@material-ui/core';

import helpSvg from '../assets/img/help.svg';
import ErrorIcon from '@material-ui/icons/Error';

import { connect, useDispatch, useSelector } from 'react-redux';
import { change, getFormValues } from 'redux-form';
import useStyles from '../styles/styles';

import { makeStyles } from '@material-ui/core/styles';
import { formName } from '../thunks/constants';
import State from '../states/State';
import { renderSummary } from '../helpers/renderHelper';
import { parseSummaryToSuiteOption } from '../helpers/suiteAdapter';

import { IoIosSnow } from 'react-icons/io';
import { ImFire } from 'react-icons/im';

const useCustomStyles = makeStyles(theme => ({
  PePricingOption_control: {
    display: 'block',
    padding: theme.spacing(2),
  },
}));

const PricingTitle: React.FC<{ readonly heatKw?: string, readonly coolKw?: string }> = ({ heatKw, coolKw }) => {
  return <Grid container spacing={2} justifyContent="space-between">
    <Grid item xs={6} container spacing={1}>
      <Grid item><IoIosSnow style={{ paddingTop: 5, color: '#7C94D4' }}/></Grid>
      <Grid item><span style={{ fontFamily: 'Oswald' }}>{coolKw}&nbsp;kW</span></Grid>
    </Grid>
    <Divider orientation="vertical" flexItem/>
    <Grid item xs={6} container spacing={1} justifyContent="flex-start">
      <Grid item><ImFire style={{ paddingTop: 5, color: '#FF971A' }}/></Grid>
      <Grid item><span style={{ fontFamily: 'Oswald' }}>{heatKw}&nbsp;kW</span></Grid>
    </Grid>
  </Grid>
}

type PePricingOverviewProps = {
  readonly input?: any,
  readonly id: string,
  readonly label: string,
  readonly required?: boolean,
  readonly options: any,
  readonly toolTip?: string,
  readonly formValues: any,
  readonly meta: {
    touched: any,
    error: any,
    form: any,
  }
}

const PePricingOverview: React.FC<PePricingOverviewProps> = ({ meta, id, label, required, toolTip, formValues, input }) => {
  const classes = useStyles();
  const classesCustom = useCustomStyles();
  const dispatch = useDispatch();

  const state = useSelector((state: State) => ({
    productChoice: state.shell.productChoice,
    summaryChoice: state.shell.summaryChoice,
    daikins: state.shell.productData?.daikins,
    peAdmin: state.shell.productData?.peAdmin,
  }));
  const { productChoice, daikins, summaryChoice, peAdmin } = state;

  const [summaryItem, setSummaryItem] = React.useState<any>(undefined);

  React.useEffect(() => {
    setSummaryItem(undefined);
    renderSummary(formValues, daikins, summaryChoice, peAdmin).then((data) => {
      setSummaryItem(data);
    });
    // eslint-disable-next-line
  }, [productChoice, summaryChoice]);

  React.useEffect(() => {
    dispatch(change(formName, 'product_choice', JSON.stringify({
      "1": {
        item: summaryItem
      }
    })));
    dispatch(change(formName, 'summary', JSON.stringify(parseSummaryToSuiteOption(daikins, summaryChoice, formValues, summaryItem))));
    // eslint-disable-next-line
  }, [summaryItem]);

  return <FormControl error={Boolean(meta?.error)} id={id} className={classesCustom.PePricingOption_control}>
    <div className={classes.labelArea}>
      <h3 className={classes.label}>
        {required && <span className={classes.required}>*</span>}&nbsp;{label}
      </h3>
      {toolTip && <Tooltip title={toolTip} TransitionComponent={Zoom} placement="right-end" arrow>
        <img src={helpSvg} alt="help" className={classes.iconHelp} />
      </Tooltip>}
    </div>

    <Grid container spacing={3} style={{ alignItems: 'flex-start' }}>
      <Grid item sm={5}>
        <Card className={classes.PePricingOption_paper}>
          <CardHeader
            className={classes.header}
            title={<PricingTitle heatKw={summaryItem?.heatKw} coolKw={summaryItem?.coolKw} />}
          />
          <CardContent style={{ width: '100%', padding: '0 0 0 24px' }}>
            {summaryItem?.result.map((item: any, key: number) => {
              return item.display && <div className={classes.line} key={"line_" + key + item.id}>
                <p className={classes.lineLeft}>{item.qty}x</p>
                <p style={{ margin: '5px 0 10px 0' }}>{item.name}</p>
              </div>
            })}
            <div className={classes.spread}></div>
            <div className={classes.priceLine} style={{ fontWeight: 'bold' }}>
              <p className={classes.lineLeft}>Purchase Price</p>
              <p style={{ margin: '5px 0  10px 0' }}>{summaryItem?.pdf?.subTotal}</p>
            </div>
            <div className={classes.priceLine}>
              <p className={classes.lineLeft}>GST</p>
              <p style={{ margin: '5px 0  10px 0' }}>{summaryItem?.pdf?.gst}</p>
            </div>
            <div className={classes.spread}></div>
            <Typography gutterBottom variant="h4"
              component="h3"
              className={classes.totalPrice}>
              {summaryItem?.totalPrice}
            </Typography>
          </CardContent>
        </Card>
      </Grid>
    </Grid>

    {meta?.error && <FormHelperText className={classes.helpText} component="div">
      <ErrorIcon fontSize="small" />
      <p style={{ margin: 0, padding: 0 }}>{" "}{meta?.error}</p>
    </FormHelperText>}
  </FormControl>
}

export default connect(state => ({
  formValues: getFormValues(formName)(state),
}))(PePricingOverview);